import { render, staticRenderFns } from "./StringWave.vue?vue&type=template&id=8d74e82e&scoped=true&"
import script from "./StringWave.vue?vue&type=script&lang=js&"
export * from "./StringWave.vue?vue&type=script&lang=js&"
import style0 from "./StringWave.vue?vue&type=style&index=0&id=8d74e82e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d74e82e",
  null
  
)

export default component.exports